import * as qs from 'qs';
import { parse as uuidParse, stringify as uuidStringify } from 'uuid';

// Query flag SPGCard adds to the SIBS redirectUrl, so the live session screen can tell a card
// form return from the MB Way ?sid= link, which carries no flag.
export const SPG_CARD_RETURN_PARAM = 'spgCard';

const bufferToBase64 = (buf) => {
  const binstr = Array.prototype.map
    .call(buf, (ch) => String.fromCharCode(ch))
    .join('');

  return btoa(binstr);
};

// base64url-encode a session UUID — same idiom used across the app
// (SessionContext / MBWayMobilePhone) to build the ?sid= deep link.
export const toBase64UrlSessionId = (sessionId: string): string => bufferToBase64(uuidParse(sessionId))
  .replace(/=+$/, '')
  .replace(/\+/g, '-')
  .replace(/\//g, '_');

// Inverse of toBase64UrlSessionId; null when the value is not a base64url-encoded UUID.
export const fromBase64UrlSessionId = (sid: string): string | null => {
  try {
    const base64 = sid.replace(/-/g, '+').replace(/_/g, '/');
    const binstr = atob(base64 + Array(((4 - (base64.length % 4)) % 4) + 1).join('='));

    if (binstr.length !== 16) {
      return null;
    }

    return uuidStringify(Uint8Array.from(binstr, (ch) => ch.charCodeAt(0)));
  } catch (e) {
    return null;
  }
};

// The session UUID when the page was reached by the SIBS card form redirect, otherwise null.
export const getSpgCardReturnSessionId = (search: string): string | null => {
  const query = qs.parse(search, { ignoreQueryPrefix: true });
  const flag = query[SPG_CARD_RETURN_PARAM];

  // The flag is the last parameter: tolerate a '?…' the gateway may append to the redirect URL.
  if (typeof flag !== 'string' || flag.split('?')[0] !== '1' || typeof query.sid !== 'string') {
    return null;
  }

  return fromBase64UrlSessionId(query.sid);
};
